import { AppState } from './app';
import * as constants from '../constants';

// We type the payload cast inside each switch case:
export type CheckoutFastbookActionType = {
  type:
    | typeof constants.PAYMENT_EVENT
    | typeof constants.FETCHED_PAYMENT_METHODS
    | typeof constants.FETCHED_SHARE_OF_TIME
    | typeof constants.SET_FASTBOOK_DATA
    | typeof constants.SET_DIGIFLEX_DATA
    | typeof constants.CLEAR_DIGIFLEX_DATA
    | typeof constants.SET_CAMPAIGN_NAME;

  payload: any;
};

export const checkoutFastbookReducer = (state: AppState, action: CheckoutFastbookActionType) => {
  switch (action.type) {
    case constants.PAYMENT_EVENT: {
      return {
        ...state,
      };
    }

    case constants.FETCHED_PAYMENT_METHODS: {
      let paymentMethodsObj = {};
      action.payload.data.forEach((method) => {
        paymentMethodsObj[method.name] = method;
      });
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          paymentMethods: action.payload.data,
          paymentMethodsObj,
        },
      };
    }

    case constants.FETCHED_SHARE_OF_TIME: {
      return state;
    }

    case constants.SET_FASTBOOK_DATA: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          fastbook: {
            ...state.userDataEC.fastbook,
            ...action.payload,
          },
        },
      };
    }

    case constants.SET_DIGIFLEX_DATA: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          digiflex: {
            ...state.userDataEC.digiflex,
            ...action.payload,
          },
        },
      };
    }

    case constants.CLEAR_DIGIFLEX_DATA: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          digiflex: {
            product: null,
            startDate: null,
            timeslot: 1,
            timeslotInfo: null,
            spotLength: 10,
            dailyTransmission: 0,
            totalTransmission: 0,
            dailyRepetitions: 0,
            shareOfTime: 0,
            isProductInBasket: false,
            invalidDaysInRange: [],
            dateRange: [],
            duration: 7,
            budget: 0,
            initData: {},
            isLoading: false,
          },
        },
      };
    }

    case constants.SET_CAMPAIGN_NAME: {
      return {
        ...state,
        userDataEC: {
          ...state.userDataEC,
          campaignName: action.payload,
        },
      };
    }
  }
};
